export function formatCurrencyUSD(amount: number | string) {
  const stripped = String(amount).replace(/([^.\d])/, "");

  return `$${Number(stripped).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}
